import { Flex, chakra } from '@chakra-ui/react';
import React from 'react';

import SurfaceCard from 'ui/shared/SurfaceCard';

interface Props {
  children: React.ReactNode;
  className?: string;
  animation?: string;
}

const ListItemMobile = ({ children, className, animation }: Props) => {
  return (
    <SurfaceCard p="12px" mb={ 3 } _last={{ mb: 0 }}>
      <Flex
        animation={ animation }
        rowGap={ 6 }
        alignItems="flex-start"
        flexDirection="column"
        className={ className }
        fontSize="16px"
        lineHeight="20px"
      >
        { children }
      </Flex>
    </SurfaceCard>
  );
};

export default chakra(ListItemMobile);
